import { z } from "zod";

const envVariables = z.object({
  VITE_BACKEND_ADDRESS: z.string().default("http://localhost:3000"),
  VITE_GOOGLE_CLIENT_ID: z.string().default("__X_GOOGLE_CLIENT_ID__"),
  VITE_AZURE_CLIENT_ID: z.string().default("__X_AZURE_CLIENT_ID__"),
  VITE_SENTRY_DSN: z.string().default("__SENTRY_DSN__"),
  VITE_SENTRY_ENVIRONMENT: z.string().default("__SENTRY_ENVIRONMENT__"),
  VITE_SENTRY_FORCE: z.string().default("false"),
  VITE_GOOGLE_ANALYTICS_ID: z.string().default(""),
  VITE_WHATSAPP_APP_ID: z.string().default("__WHATSAPP_APP_ID__"),
  VITE_WHATSAPP_CONFIG_ID: z.string().default("__WHATSAPP_CONFIG_ID__"),
  VITE_CONTACT_EMAIL: z.string().default("__CONTACT_EMAIL__"),
  VITE_SIMULATED_LATENCY: z.coerce.number().default(0),
  VITE_MAINTENANCE_MODE: z.string().default("false"),
  VITE_ORG_INLINE_MAX: z.coerce.number().default(5),
  VITE_SIP_DOMAIN: z.string().default("sip.sippulse.ai"),
  VITE_TURNSTILE_SITE_KEY: z.string().default(""),
});

const environment = envVariables.safeParse(import.meta.env);

if (!environment.success) {
  const message = `One or more environment variables failed:\n${z.prettifyError(environment.error)}`;

  throw new Error(message);
}

export default environment.data;
